<template>
    <div class="cart-quantity goods-counter justify-content-end justify-content-md-start">
        <div class="goods-counter">
            <BIconDash
                :class="{ disabled: minusDisabled }"
                @click="minus"
                font-scale="2"
            />

            <input
                type="text"
                v-model.number="innerValue"
                class="quantity"
                @change="change"
            >

            <BIconPlus @click="plus" font-scale="2"/>
        </div>

        <Remove
            v-if="showRemove"
            :cart-position-id="id"
        />
    </div>
</template>

<script>

import {EVENT_ON_CART_UPDATE} from "@/events";
import {BIconPlus, BIconDash} from 'bootstrap-vue';

export default {
    components: {
        Remove: () => import('./Remove'),
        BIconPlus,
        BIconDash,
    },
    props: {
        id: {
            type: Number,
            required: true
        },
        value: {
            type: Number,
            required: true
        },
        min: {
            type: Number,
            default: 1
        },
        step: {
            type: Number,
            default: 1
        },
        showRemove: {
            type: Boolean,
            default: true,
        }
    },
    created() {
        this.innerValue = this.value;
        this.$root.$on(EVENT_ON_CART_UPDATE, this.onCartChanged);
    },
    beforeDestroy() {
        this.$root.$off(EVENT_ON_CART_UPDATE, this.onCartChanged);
    },
    data() {
        return {
            innerValue: null,
        }
    },
    computed: {
        minusDisabled() {
            return this.value === this.min;
        }
    },
    methods: {
        minus() {
            const newValue = Number((this.innerValue - this.step).toFixed(2));
            if (newValue < this.min) {
                return;
            }
            this.innerValue = newValue;
            this.change();
        },
        plus() {
            this.innerValue = Number((this.innerValue + this.step).toFixed(2));
            this.change();
        },
        onCartChanged(data) {
            const found = data.items.find(item => item.id === this.id);
            if (found !== undefined) {
                this.innerValue = found.quantity;
            }
        },
        change() {
            if (this.innerValue !== null) {
                return this.$http({
                    method: 'POST',
                    url: '/cart/update',
                    data: {quantity: this.innerValue},
                    params: {id: this.id}
                }).then(({data}) => {
                    this.$root.$emit(EVENT_ON_CART_UPDATE, data);
                });
            }
        },
    },
}
</script>

<style lang="scss" scoped>

.cart-quantity {
    display: flex;
    align-items: center;

    .b-icon {
        cursor: pointer;

        &.disabled {
            cursor: not-allowed;
            opacity: .33;
        }
    }

    .quantity {
        text-align: center;
        /*width: 75px;*/
        width: 60px;
    }

    .bi-trash {
        color: rgb(229, 43, 55);
    }
}

</style>
